import React from "react";
import './firstName.css';

export default () => (
  <span className="user_first_name">
    Boris Livshutz
  </span>
);


// WEBPACK FOOTER //
// ./src/components/userName/firstName/firstName.js